import { theme, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilm } from "@fortawesome/free-solid-svg-icons";
import nuvoLogo from "../../assets/images/dummy-nuvo-logo.svg";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import DummyLogo from "../../assets/images/dummy-logo.svg";

const { Title, Paragraph } = Typography;

function SectionOne() {
  const { token } = theme.useToken();
  const user = useSelector(authorizeSelectors.user);

  const companyLogoSrc = user?.userCmpLogoSrc
    ? user?.userCmpLogoSrc
    : DummyLogo;

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {/* NUVO Logo */}
      <div className="mb-12 flex justify-end">
        <img
          src={nuvoLogo}
          alt="NUVO Logo"
          className="h-[60px] w-[70px] object-contain"
        />
      </div>

      {/* Company Logo */}
      <div className="mb-60 flex justify-center">
        <img
          src={companyLogoSrc}
          alt="Company Logo"
          className="h-40 object-contain"
        />
      </div>

      {/* Title */}
      <Title
        level={2}
        className="mb-2 text-4xl"
        style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
      >
        Explore The World of NUVO WELL
      </Title>

      {/* Description */}
      <div className="mb-12 max-w-6xl text-lg leading-relaxed">
        <Paragraph
          className="text-justify"
          style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
        >
          The Guidance Program aims to assist organizations in designing,
          developing and establishing and improving wellbeing policies to ensure
          the psychological health and safety of their employees by
          understanding the significance of workplace risk factors and their
          implication on employee psychological health and safety, an
          understanding of the key drivers and risk factors of workplace
          wellbeing, implementing psychosocial risk assessments, providing
          employees with information and trainings on wellbeing, evaluating and
          monitoring wellbeing practices, developing resources and toolkits for
          addressing critical incidents and supporting mental health issues in
          the workplace.
        </Paragraph>

        <Paragraph
          className="text-justify"
          style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
        >
          A wellbeing policy can help improve the organizational culture,
          productivity, performance, prevent stress, decrease illness absences,
          reduce turnover, improve employee sustainability and increase
          resilience, factors that contribute to overall health.
        </Paragraph>
      </div>

      {/* Introductory video placeholder — the client-supplied clip will replace this. */}
      <div
        className="mx-auto flex aspect-video w-full max-w-6xl flex-col items-center justify-center overflow-hidden rounded-lg"
        style={{
          background:
            "linear-gradient(135deg, rgba(20,160,152,0.08) 0%, rgba(13,122,115,0.14) 100%)",
          border: "1px solid rgba(20,160,152,0.2)",
        }}
      >
        <FontAwesomeIcon
          icon={faFilm}
          style={{ fontSize: 72, color: token.colorPrimary, opacity: 0.5 }}
        />
        <Typography.Text
          className="mt-3 text-base"
          style={{ color: token.colorPrimary, opacity: 0.75 }}
        >
          Introductory video — coming soon
        </Typography.Text>
      </div>
    </section>
  );
}

export default SectionOne;
